/**
 * Полоса готовности.
 *
 * Показывает только объективный счёт «выполнено из всего» — произвольный
 * процент готовности в системе не используется (документ «Итоговое описание»,
 * §16.2). Значение продублировано текстом для доступности.
 */

import { cn } from '@/lib/utils';

export function Progress({
  value,
  max,
  label,
  className,
}: {
  value: number;
  max: number;
  label: string;
  className?: string;
}) {
  const safeMax = Math.max(max, 0);
  const ratio = safeMax === 0 ? 0 : Math.min(value / safeMax, 1);
  const complete = safeMax > 0 && value >= safeMax;

  return (
    <div
      role="progressbar"
      aria-valuenow={value}
      aria-valuemin={0}
      aria-valuemax={safeMax}
      aria-label={label}
      title={label}
      className={cn('h-1.5 w-full overflow-hidden rounded-full bg-muted', className)}
    >
      <div
        className={cn(
          'h-full rounded-full transition-[width] duration-300',
          complete ? 'bg-tone-success' : 'bg-primary',
        )}
        style={{ width: `${ratio * 100}%` }}
      />
    </div>
  );
}
